import { FetchPracticeById } from './types';

import axiosInstance from '../../../axiosInstance';

export const fetchPracticeDetailsId = async (
  payload: FetchPracticeById,
  { dispatch }
) => {
  try {
    const res = await axiosInstance.get(`practice/${payload.data.practiceId}`, {
      headers: {
        Authorization: `Bearer ${payload.accessToken}`
      }
    });
    return res.data;
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg ||
        'An error occurred while fetching practice details.'
    );
  }
};

export const getUsersByPracticeId = async (payload: FetchPracticeById) => {
  try {
    const res = await axiosInstance.get(
      `practice/${payload?.data?.practiceId}/users`,
      {
        headers: {
          Authorization: `Bearer ${payload?.accessToken}`
        }
      }
    );
    return res?.data;
  } catch (err) {
    throw new Error(
      err?.response?.data?.msg || 'An error occurred while fetching users.'
    );
  }
};
